import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
var UiNotificationService = /** @class */ (function () {
    function UiNotificationService(document) {
        this.document = document;
        this.DEFAULT_ERROR_DURATION = 10000;
        this.DEFAULT_SUCCESS_DURATION = 3000;
        this.activeNotifications = [];
        this.NOTIFICATION_GAP = 10;
        this.NOTIFICATION_MIN_HEIGHT = 60;
    }
    UiNotificationService.prototype.showError = function (message, duration) {
        if (duration === void 0) { duration = this.DEFAULT_ERROR_DURATION; }
        this.createNotification('error', message, duration);
    };
    UiNotificationService.prototype.showSuccess = function (message, duration) {
        if (duration === void 0) { duration = this.DEFAULT_SUCCESS_DURATION; }
        this.createNotification('success', message, duration);
    };
    UiNotificationService.prototype.showInfo = function (message, duration) {
        if (duration === void 0) { duration = this.DEFAULT_SUCCESS_DURATION; }
        this.createNotification('info', message, duration);
    };
    UiNotificationService.prototype.showWarning = function (message, duration) {
        if (duration === void 0) { duration = this.DEFAULT_SUCCESS_DURATION; }
        this.createNotification('warn', message, duration);
    };
    UiNotificationService.prototype.handleHttpError = function (error) {
        var errorMessage = 'Сталася помилка при виконанні запиту';
        if (error.status === 0) {
            errorMessage = "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0437'\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C \u0430\u0431\u043E CORS. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443 \u0456 \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440";
        }
        else if (error.status === 401) {
            errorMessage = 'Необхідна авторизація. Увійдіть у систему';
        }
        else if (error.status === 403) {
            errorMessage = 'Доступ заборонено. У вас немає прав для виконання цієї дії';
        }
        else if (error.status === 404) {
            errorMessage = 'Ресурс не знайдено';
        }
        else if (error.status >= 500) {
            errorMessage = 'Помилка сервера. Спробуйте пізніше';
        }
        if (error.error && error.error.message) {
            errorMessage = error.error.message;
        }
        this.showError(errorMessage + "</br>" + error.url + "</br>" + error.message + "</br>" + (error.error.stack || ''));
    };
    UiNotificationService.prototype.handleClientError = function (error) {
        this.showError(error.stack);
    };
    UiNotificationService.prototype.positionNotification = function (notification) {
        var _this = this;
        var topPosition = 20;
        if (this.activeNotifications.length > 0) {
            var totalHeight_1 = 0;
            this.activeNotifications.forEach(function (activeNotification) {
                var height = activeNotification.offsetHeight || _this.NOTIFICATION_MIN_HEIGHT;
                totalHeight_1 += height + _this.NOTIFICATION_GAP;
            });
            topPosition = 20 + totalHeight_1;
        }
        notification.style.top = topPosition + "px";
        this.activeNotifications.push(notification);
        this.recalculatePositions();
    };
    UiNotificationService.prototype.repositionNotifications = function (removedNotification) {
        var index = this.activeNotifications.indexOf(removedNotification);
        if (index !== -1) {
            this.activeNotifications.splice(index, 1);
            this.recalculatePositions();
        }
    };
    UiNotificationService.prototype.recalculatePositions = function () {
        var _this = this;
        var currentTop = 20;
        this.activeNotifications.forEach(function (notification, index) {
            notification.style.top = currentTop + "px";
            var height = notification.offsetHeight || _this.NOTIFICATION_MIN_HEIGHT;
            currentTop += height + _this.NOTIFICATION_GAP;
        });
    };
    UiNotificationService.prototype.removeNotification = function (notification) {
        if (this.document.body.contains(notification)) {
            this.document.body.removeChild(notification);
            this.repositionNotifications(notification);
        }
    };
    UiNotificationService.prototype.createNotification = function (type, message, duration) {
        var _this = this;
        var notification = this.document.createElement('div');
        notification.innerHTML = message;
        notification.className = "ui-notification ui-notification-" + type;
        notification.style.cssText = "\n      position: fixed;\n      right: 20px;\n      padding: 15px 20px;\n      border-radius: 4px;\n      max-width: 750px;\n      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n      z-index: 9999;\n      animation: fadeIn 0.3s ease-out forwards;\n      opacity: 0;\n      min-height: " + (this.NOTIFICATION_MIN_HEIGHT - 30) + "px;\n      box-sizing: border-box;\n      display: block;\n    ";
        this.positionNotification(notification);
        if (type === 'error') {
            notification.style.backgroundColor = '#f44336';
            notification.style.color = 'white';
        }
        else if (type === 'success') {
            notification.style.backgroundColor = '#4caf50';
            notification.style.color = 'white';
        }
        else if (type === 'warn') {
            notification.style.backgroundColor = '#ff9800';
            notification.style.color = 'white';
        }
        else {
            notification.style.backgroundColor = '#2196f3';
            notification.style.color = 'white';
        }
        var closeButton = this.document.createElement('span');
        closeButton.innerHTML = '&times;';
        closeButton.style.cssText = "\n      position: absolute;\n      top: 5px;\n      right: 10px;\n      cursor: pointer;\n      font-size: 20px;\n    ";
        closeButton.onclick = function () { return _this.removeNotification(notification); };
        notification.appendChild(closeButton);
        var style = this.document.createElement('style');
        style.innerHTML = "\n      @keyframes fadeIn {\n        from { opacity: 0; transform: translateY(-20px); }\n        to { opacity: 1; transform: translateY(0); }\n      }\n      @keyframes fadeOut {\n        from { opacity: 1; transform: translateY(0); }\n        to { opacity: 0; transform: translateY(-20px); }\n      }\n    ";
        this.document.head.appendChild(style);
        this.document.body.appendChild(notification);
        setTimeout(function () {
            notification.style.animation = 'fadeOut 0.3s ease-in forwards';
            setTimeout(function () {
                _this.removeNotification(notification);
            }, 300);
        }, duration);
    };
    UiNotificationService.ngInjectableDef = i0.defineInjectable({ factory: function UiNotificationService_Factory() { return new UiNotificationService(i0.inject(i1.DOCUMENT)); }, token: UiNotificationService, providedIn: "root" });
    return UiNotificationService;
}());
export { UiNotificationService };
